import { defineStore } from 'pinia';
import type { CartDiscountRaw } from '~~/types/discounts';

export const cartDiscountsStore = defineStore('cartDiscounts', {
  state: (): {
    cartDiscountsByKey: Record<string, CartDiscountRaw | null>,
    pendingKeys: string[],
  } => ({
    // `null` means "loaded, but not available in this store"
    cartDiscountsByKey: {},
    pendingKeys: [],
  }),
  getters: {
    /**
     * Keys we neither hold a result for nor are already fetching, so a second
     * caller asking for the same discounts never triggers a second request.
     */
    keysToLoad: (state) => {

      return (discountKeys: string[]) => discountKeys.filter(
        discountKey => !(discountKey in state.cartDiscountsByKey) && !state.pendingKeys.includes(discountKey),
      );

    },
  },
  actions: {
    addPendingKeys(discountKeys: string[]) {

      this.pendingKeys = [...this.pendingKeys, ...discountKeys];

    },
    removePendingKeys(discountKeys: string[]) {

      this.pendingKeys = this.pendingKeys.filter(pendingKey => !discountKeys.includes(pendingKey));

    },
    setCartDiscounts(payload: { discountKeys: string[], results: CartDiscountRaw[] }) {

      const resultsByKey = new Map(payload.results.map(result => [result.key, result]));

      this.cartDiscountsByKey = {
        ...this.cartDiscountsByKey,
        // every requested key gets an entry, so a discount missing from the
        // response is remembered as unavailable instead of being fetched again
        ...Object.fromEntries(
          payload.discountKeys.map(discountKey => [discountKey, resultsByKey.get(discountKey) || null]),
        ),
      };

    },
  },
});
